import { createElementBlock as d, openBlock as l, normalizeStyle as m, createCommentVNode as f, renderSlot as _, toDisplayString as b, createElementVNode as w, ref as p, onMounted as E, onUnmounted as I, computed as n } from "vue";
import { g as z } from "../lib/colour.D5peZoOG.js";
import B from "lodash/isString";
import { _ as N } from "../plugin-vue.CHgC5LLL.js";
import '../../assets/components/AvatarIcon.css';const y = 576, k = 30, x = 40, C = {
  name: "AvatarIcon",
  props: {
    id: {
      type: String,
      required: !0
    },
    displayName: {
      type: String,
      required: !0
    },
    scale: {
      type: Number,
      default: 1
    },
    showInitials: {
      type: Boolean,
      default: !0
    },
    connected: {
      type: Boolean,
      default: !1
    },
    isArchived: {
      type: Boolean,
      default: !1
    },
    showLargeArchivedBadge: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const i = p(null), a = p(window.innerWidth <= y);
    function r() {
      a.value = window.innerWidth <= y;
    }
    E(() => {
      window.addEventListener("resize", r);
    }), I(() => {
      window.removeEventListener("resize", r);
    });
    const s = n(() => {
      if (!B(t.displayName))
        return "";
      const e = t.displayName.split(" ");
      return e.length > 1 ? e.reduce((h, A) => h + A.charAt(0), "") : e[0].charAt(0);
    }), c = n(() => a.value ? k : x), o = n(() => c.value * t.scale), u = n(() => {
      const e = parseInt(o.value, 10);
      return s.value.length > 3 ? `${e / (s.value.length - 1)}px` : `${e / 2}px`;
    }), S = n(() => `${parseInt(o.value, 10) / 2 * 0.35}px`), v = n(() => {
      if (t.isArchived)
        return "#6c757d";
      const e = `${t.id}-${t.displayName}`;
      return z(e);
    }), g = n(() => ({
      backgroundColor: v.value,
      fontSize: u.value,
      width: `${o.value}px`,
      height: `${o.value}px`
    }));
    return {
      initials: s,
      backgroundColor: v,
      avatar: i,
      fontSize: u,
      avatarSize: o,
      dynamicAvatarStyle: g,
      onlineIndicatorPadding: S
    };
  }
}, $ = {
  key: 0,
  "data-dd-privacy": "mask"
};
function L(t, i, a, r, s, c) {
  return l(), d("div", {
    ref: "avatar",
    class: "cc-avatar",
    style: m(r.dynamicAvatarStyle),
    "data-testid": "avatar"
  }, [
    a.showInitials ? (l(), d("span", $, b(r.initials.toUpperCase()), 1)) : f("", !0),
    _(t.$slots, "connected", { connected: a.connected }, () => [
      a.connected ? (l(), d("span", {
        key: 0,
        style: m({ padding: r.onlineIndicatorPadding }),
        class: "floating-badge bg-success border border-light rounded-circle"
      }, i[0] || (i[0] = [
        w("span", { class: "visually-hidden" }, "User online", -1)
      ]), 4)) : f("", !0)
    ])
  ], 4);
}
const q = /* @__PURE__ */ N(C, [["render", L]]);
export {
  q as A
};
